import { useEffect, useMemo } from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { withCrmReturnUrl } from '@/config/externalPortals';

const { Title, Text } = Typography;

interface ExternalRedirectPageProps {
  targetUrl: string;
  title: string;
  message: string;
  includeReturnUrl?: boolean;
}

export default function ExternalRedirectPage({
  targetUrl,
  title,
  message,
  includeReturnUrl = true,
}: ExternalRedirectPageProps) {
  const redirectUrl = useMemo(
    () => (includeReturnUrl ? withCrmReturnUrl(targetUrl) : targetUrl),
    [includeReturnUrl, targetUrl]
  );

  useEffect(() => {
    window.location.replace(redirectUrl);
  }, [redirectUrl]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#f6f8fb',
        padding: 24,
      }}
    >
      <Card style={{ width: 'min(420px, 100%)', borderRadius: 8 }}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          <Text type="secondary">{message}</Text>
          <Button type="primary" href={redirectUrl} icon={<ExportOutlined />} block>
            前往外部系統
          </Button>
        </Space>
      </Card>
    </div>
  );
}
